import { PlayerContextState } from "../../../PlayerContext";
import { EquipmentSlot } from "../../Equipment";
import { ItemParams } from "../../Item";
import { EquippableItem } from "../EquippableItem";

class FullPlate extends EquippableItem {
  getId(): string {
    return "fullPlate";
  }

  getPicture(): string {
    return require("./fullPlate.png");
  }

  getBaseName(): string {
    return "Full Plate";
  }

  getDescription(): string | undefined {
    return "A full armor, made out of iron. Provides very strong protection, at the cost of movement speed.";
  }

  getDefenseBonus(state: PlayerContextState, params: ItemParams): number {
    return 35;
  }

  getAttackDelayBonusPct(
    state: PlayerContextState,
    params: ItemParams,
  ): number {
    return 10;
  }

  getSlot(): EquipmentSlot {
    return EquipmentSlot.Body;
  }

  getSalePrice(): number {
    return 10000;
  }

  getCraftingSchoolLevelRequirements() {
    return { Conjuration: 13 };
  }

  getCraftingMaterialsBase() {
    return {
      resources: {
        Iron: 8000,
        Temperature: 4500,
      },
      items: {},
    };
  }
}

export default new FullPlate();
